import { css } from 'reakit/styled';
import { palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
var Table = {
  base: css(["color:", ";"], palette('text200')),
  Cell: {
    base: css(["padding:1rem 0.5rem;"])
  },
  HeadCell: {
    base: css(["color:", ";font-size:12px;line-height:2;margin-bottom:0px;text-transform:uppercase;"], palette('text100'))
  }
};
export default Table;